<template>
  <base-input
    type="text"
    v-model="alias"
    ref="baseinput"
    :label="StringLanguage.storeAlias"
    :placeholder="placeholder"
    :valid="isValid"
    @keyup="$emit('keyup')"
    @keydown.space.prevent
    @input="handleInput"
    @focus="onFocus()"
    @blur="validate()"
    :design="`${!!design ? `${design}` : ''}`"
  />
</template>

<script>
import BaseInput from "@/components/Input";
import { baseEvents } from "@/mixins/baseEvents.js";
import StoreSchema from "easyjs/lib/Schema/Store";

export default {
  mixins: [baseEvents],
  components: {
    BaseInput,
  },
  mounted() {
    this.inputId = this.$refs.baseinput.id;
  },
  data() {
    return {
      alias: this.value || "",
      isValid: true,
      inputId: "",
    };
  },
  props: {
    design: String,
    placeholder: { type: String, default: null }
  },
  methods: {
    validate() {
      if (this.alias === "" || this.alias.length < 5 || this.alias.length > 20) {
        this.isValid = false;
        this.$parent.setErrorValidation(this.inputId, "7001");
        return;
      }

      const letters = this.alias.match(/[a-z]/g);
      if (!letters || letters.length < 3) {
        this.isValid = false;
        this.$parent.setErrorValidation(this.inputId, "7002");
        return;
      }

      if (!this.alias.match(/^[0-9a-z]+$/i)) {
        this.isValid = false;
        this.$parent.setErrorValidation(this.inputId, "7003");
        return;
      }

      this.isValid = true;
    },
    onFocus() {
      this.isValid = true;
      this.$parent.removeErrorValidation(this.inputId);
    },
    handleInput(e) {
      this.alias = this.alias.toLowerCase();
      this.$emit("input", this.alias);
    },
  },
};
</script>